
export default function ProjectCard({ image, title, description, features = [], link }) {

    console.log("IMAGE PATH RECEIVED BY CARD:", image);


  return (
    <div className="product_card">
                 
        <div
          className="project_image"
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            minHeight:"250px",
            maxHeight: "250px",
          }}
        >
        </div>


        <div className="project_about">
          <h4>{title}</h4>
          <p>{description}</p>

          {features.length > 0 && (
            <>
              <h5>Features:</h5>
              <ul>
                {features.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </>
          )}

          <div className="button_container">
            <a href={link} className="cta_Button Arrow_button">
              Show Project <span className="text-xl">→</span>
            </a>
          </div>

        </div>
    </div>
  );
}
